export const SetLookUpData = (data) => {
  return {
    type: "SETLOOKUPDATA",
    payload: data
  };
}
